<div class="question">
  @switch (parameter.type) { @case (1) {
  <question-number
    [minValue]="parameter.minValue"
    [maxValue]="parameter.maxValue"
    [title]="parameterLabel"
    [value]="parameter.value"
    (valueChanged)="updateParameter($event)"
    [isEmpty]="parameter.value == null && parameter.parameterId !== NIL_UUID"
  ></question-number>
  } @case (2) {
  <question-yesno-buttons [title]="parameterLabel" [value]="parameter.value | StringToBoolean" (valueChanged)="updateParameter($event)">
  </question-yesno-buttons>
  } @case (3) {
  <question-options
    [title]="parameterLabel"
    [options]="parameter.options | StringToOptions : parameter.value"
    (valueChanged)="updateParameter($event)"
  ></question-options>
  } @case (4) {
  <question-multi-option
    [title]="parameterLabel"
    [options]="parameter.options | StringToOptions : parameter.value"
    (valueChanged)="updateParameter($event)"
  ></question-multi-option>
  } } @if (parameter.parameterComments.length > 0) {
  <button class="show-comments" title="Show comments" (click)="isExpanded = !isExpanded">
    <mat-icon>comment</mat-icon>
    {{ parameter.parameterComments.length }}
  </button>
  } @else { @if (parameter.parameterId != NIL_UUID) {
  <button class="show-comments-hidden" title="Comment" (click)="isExpanded = !isExpanded">
    <mat-icon>comment</mat-icon>
  </button>
  } }
</div>
@if (isExpanded) {
<div class="expanded-comments">
  <div class="comments-header">
    comments
    <button class="close-comments" (click)="isExpanded = false">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="add-comment">
    <div class="user-image-container">
      @if (userImage$ | async; as userImage) {
      <img [src]="userImage" class="user-photo" />
      } @else {
      <mat-icon class="user-photo-placeholder">person</mat-icon>
      }
    </div>
    <div class="add-comment-content">
      Write a comment
      <textarea class="textarea" type="text" [formControl]="content"></textarea>
      <div class="add-comment-button">
        <button (click)="addComment()" class="iconf-btn-filled minw150 margin-border minh40">save</button>
      </div>
    </div>
  </div>
  @for (comment of parameter.parameterComments; track comment) {
  <question-comment [comment]="comment" (refresh)="refreshQuestion()"></question-comment>
  }
</div>
}
